import AccountBalanceInput from "../../../components/Accounts/AccountBalanceInput";
import Layout from "../../../components/Accounts/Layout";
import { Hrule } from "../../../components/AddUser/AddUserContainer";
import { CloseIcon } from "../../../../public/assets";
import { styled } from "styled-components";
import RadioButtonComponent, {
  ItemTypeProps,
} from "../../../components/RadioButtonComponent";
import { useQuery } from "@apollo/client";
import { fetchBeneficiaryDetails } from "../../../graphql/queries/accounts";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import { getBeneficiaryDetails } from "../../../utils/getBeneficaryDetail";

export interface Beneficiary {
  recipientFullName?: string | null;
  recipientBankName?: string | null;
  recipientAccountNumber?: string | null;
  recipientPhoneNumber?: string | null;
  recipientTag?: string | null;
}
export interface SelectBeneficiaryProps {
  slideIn: boolean;
  onClose: () => void;
  activeType: string;
  onTypeChange: (value: string) => void;
  transferType: string;
}
const SelectBeneficiary: React.FC<SelectBeneficiaryProps> = ({
  slideIn,
  onClose,
  activeType,
  onTypeChange,
  transferType,
}) => {
  const id = useSelector((state: RootState) => state.user?.user?.id);

  const {
    loading: loadingBeneficiary,
    error: beneficiaryError,
    data: beneficiaryData,
  } = useQuery(fetchBeneficiaryDetails, {
    variables: { userId: id },
  });

  const beneficiaryList: Beneficiary[] = Array.isArray(
    beneficiaryData?.fetchBeneficiaryDetails
  )
    ? beneficiaryData?.fetchBeneficiaryDetails
    : [];

  const beneficiaries: ItemTypeProps[] = getBeneficiaryDetails(
    beneficiaryList,
    transferType
  );
  return (
    <ModalWrapper>
      <InnerContainer slideIn={slideIn}>
        <Wrapper>
          <p>Select Beneficiary</p>
          <CloseIconImg src="/assets/icons/close.svg" onClick={onClose} />
        </Wrapper>
        <Hrule />
        <AccountBalanceInput placeholder={"Search..."} />
        {loadingBeneficiary ? (
          <LoadingText>Loading Beneficiaries...</LoadingText>
        ) : (
          <RadioComponent>
            <RadioButtonComponent
              itemTypes={beneficiaries}
              onTypeChange={onTypeChange}
              activeType={activeType}
              center
              textColor
              style={{
                color: "#CFCFCF",
                borderBottom: "1px solid #e8eaed",
                width: "100%",
              }}
            />
          </RadioComponent>
        )}
      </InnerContainer>
    </ModalWrapper>
  );
};

export default SelectBeneficiary;
export const ModalWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-end;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
`;

const CloseIconImg = styled.img`
  cursor: pointer;
  width: 30px;
  height: 30px;
`;
const InnerContainer = styled.div<{ slideIn: boolean }>`
  position: absolute;
  left: 0;
  width: 100%;
  transition: bottom 0.3s ease-in-out;
  bottom: ${({ slideIn }) => (slideIn ? "0" : "-100%")};
  border: 1px solid #e8eaed;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding: 0.5rem;
  z-index: 100;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  height: 91%;
`;
const Wrapper = styled.div`
  display: flex;
  align-items: center;

  justify-content: space-between;
  p {
    color: #5e5e5e;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 2%;
    margin: 0;
    padding: 0;
  }
`;
export const RadioComponent = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 1rem;

  & > div:last-child {
    border-bottom: none !important;
  }
  @media screen and (max-width: 767px) {
  }
`;

export const LoadingText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
`;
